import { Button, Text } from "@chakra-ui/react";
import Modal from "../Modal";
import { useState } from "react";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

interface NewResetDefaultModalProps {
    isOpen: boolean;
    onClose: () => void;
    userId: string;
  }

const ResetDefaultPasswordModal = (props: NewResetDefaultModalProps) => {

    const { t } = useTranslation("translations");

    const CancelEntity = (
        <Button
          onClick={(e) => {
            props.onClose();
          }}
          className="mr-2"
          name={"Cancel"}
          colorScheme={"gray"}
          variant={"outline"}
        >
          {" "}
          Cancel{" "}
        </Button>
      );
          
      const resetToDefaultPassword = async() => {
        try{
            const res = await getAxiosInstance().post(`/Password/ResetToDefault/${props.userId}`);
            if(res.status === 200){
              props.onClose();
              toast.success("Updated user password to default", {position: toast.POSITION.BOTTOM_RIGHT});
            }
        }catch(error){ 
            toast.error("Could not reset password to default", { position: toast.POSITION.BOTTOM_RIGHT });
        }
      }
    

    return (
        <>
        <Modal
           header={t("Reset User Password")}
           isOpen={props.isOpen}
           onClose={() => {props.onClose()}}
           secondaryActionName={t("Save")}
           secondaryActionEnabled={true}
           secondaryAction={() => { resetToDefaultPassword()}}
           additionalBtn={CancelEntity}
        >
          <Text size={"md"}> User password will be reset to default password. Are you sure you want to reset password?</Text>
          
        </Modal>
        </>
    )
}


export default ResetDefaultPasswordModal;